import {LANG_OPTIONS} from "@/components/Providers/LanguageProvider";

export function removeLocale(url: string) {
    const regExp = new RegExp(LANG_OPTIONS.map(o => `^\/${o.locale}`).join('|'), 'g');
    return url.replace(regExp, '');
}

